import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Categories from "@/components/Categories";
import FeaturedListings from "@/components/FeaturedListings";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import { HomeSEO } from "@/components/SEOHead";
import AdSlot from "@/components/ads/AdSlot";
import AIHealthcareSection from "@/components/home/AIHealthcareSection";
import TrendingHealthcare from "@/components/home/TrendingHealthcare";
import TrustStrip from "@/components/home/TrustStrip";
import GlobalReadyStrip from "@/components/home/GlobalReadyStrip";
import PopularCityLinks from "@/components/home/PopularCityLinks";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <HomeSEO />
      <Header />
      <main className="flex-1">
        <Hero />
        <Categories />

        <div className="container mx-auto px-4 py-2">
          <AdSlot placement="home" type="banner" maxAds={1} />
        </div>

        <TrendingHealthcare />
        <AIHealthcareSection />
        <FeaturedListings />
        <TrustStrip />
        <PopularCityLinks />
        <GlobalReadyStrip />

        <div className="container mx-auto px-4 py-2">
          <AdSlot placement="home" type="inline" maxAds={1} />
        </div>

        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
